var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 0.5V15.5H20.333V0.5H0.333008Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8402_51868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 0.5V15.5H20.333V0.5H0.333008Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8402_51868)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 0.5V5.5H20.333V0.5H0.333008Z",
    fill: "#FF8C1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 10.5V15.5H20.333V10.5H0.333008Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83301 8C7.83301 9.38071 8.9523 10.5 10.333 10.5C11.7137 10.5 12.833 9.38071 12.833 8C12.833 6.61929 11.7137 5.5 10.333 5.5C8.9523 5.5 7.83301 6.61929 7.83301 8ZM12.208 8C12.208 9.03553 11.3685 9.875 10.333 9.875C9.29747 9.875 8.45801 9.03553 8.45801 8C8.45801 6.96447 9.29747 6.125 10.333 6.125C11.3685 6.125 12.208 6.96447 12.208 8Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3301 8.53794L9.80887 10.459L10.1141 8.49203L8.85656 10.035L9.93545 8.36224L8.15904 9.26036L9.82504 8.171L7.83691 8.26895L9.80196 7.9514L7.94588 7.23223L9.87019 7.74139L8.46709 6.32946L10.0179 7.57729L9.31044 5.71673L10.2197 7.48747L10.3301 5.5L10.4405 7.48747L11.3497 5.71673L10.6422 7.57729L12.1931 6.32946L10.79 7.74139L12.7143 7.23223L10.8582 7.9514L12.8233 8.26895L10.8351 8.171L12.5011 9.26036L10.7247 8.36224L11.8036 10.035L10.5461 8.49203L10.8513 10.459L10.3301 8.53794Z",
    fill: "#3D58DB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon);
export default __webpack_public_path__ + "static/media/in-icon.46e09d0efc108e5cb33d15240238c39e.svg";
export { ForwardRef as ReactComponent };